import { render } from "./Download.vue?vue&type=template&id=58c36b78"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"

import "./Download.vue?vue&type=style&index=0&id=58c36b78&lang=less"
script.render = render

export default script